import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Input, Button } from 'antd';
import BikeList from './BikeList';
import BikeAdvancedSearch from './BikeAdvancedSearch';
import { searchBikesRequest, setBikeManagementFilter } from '../redux/actions/search_bikes.actions';


class BikeSearch extends Component {
    state = {
        searchData: '',
    };

    searchBlock = { display: 'block', margin: '12% auto 5% auto', width: '60%' };

    advancedSearchStyle = {
        textAlign: 'center', margin: '0 0 0 30px', cursor: 'pointer', fontWeight: 600,
    };

    goToAdvancedSearch = () => this.props.dispatch({ type: 'SWITCH_SEARCH', payload: true });

    handleSearchField = ({ target: { value } }) => this.props.dispatch(setBikeManagementFilter({ db_key: 'model_OR_brand', value }));

    showTable = () => this.props.dispatch({ type: 'SHOW_TABLE', payload: true });


    searchBikes = () => {
        this.props.dispatch(searchBikesRequest());
    };

    render() {
        const {
            searchedData, isShow, amount, loading, where, pagination, advancedSearch,
        } = this.props; const
            { searchData } = this.state;
        return (
            <Fragment>
                {
                    isShow
                        ? (
                            <BikeList
                                loading={loading}
                                amount={amount}
                                where={where}
                                pagination={pagination}
                                searchedData={searchedData}
                            />
                        )
                        : advancedSearch
                            ? <BikeAdvancedSearch />
                            : (
                                <div style={this.searchBlock}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Input
                                            style={{ width: '100%', fontSize: 30, padding: '30px 20px' }}
                                            value={this.props.model_OR_brand_value}
                                            onChange={this.handleSearchField}
                                            onPressEnter={this.props.model_OR_brand_value && this.props.model_OR_brand_value.length ? this.searchBikes : null}
                                            placeholder={this.props.model_OR_brand.display_name}
                                        />
                                        <Button
                                            size="large"
                                            loading={loading}
                                            type="primary"
                                            disabled={!this.props.model_OR_brand_value}
                                            onClick={this.props.model_OR_brand_value && this.props.model_OR_brand_value.length ? this.searchBikes : null}
                                            style={{
                                                marginLeft: 30, height: 62, padding: '0 30px', fontSize: 30,
                                            }}
                                        >
                                            Search
                                        </Button>
                                    </div>
                                    <div style={{
                                        display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 30,
                                    }}
                                    >
                                        <Button disabled={this.props.amount === 0 || this.props.amount === '0'} onClick={this.showTable}>
                                            {this.props.amount !== 0 ? `Found ${this.props.amount} bikes, see results` : `Found ${this.props.amount} bikes`}
                                        </Button>
                                        <p style={this.advancedSearchStyle} onClick={this.goToAdvancedSearch}>Advanced Search</p>
                                    </div>

                                </div>
                            )
                }
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    searchedData: state.PlatformManagement.Bike_management.searchedData,
    isShow: state.PlatformManagement.Bike_management.isShow,
    loading: state.PlatformManagement.Bike_management.loading,
    amount: state.PlatformManagement.Bike_management.amount,
    where: state.PlatformManagement.Bike_management.where,
    pagination: state.PlatformManagement.Bike_management.pagination,
    advancedSearch: state.PlatformManagement.Bike_management.advancedSearch,
    model_OR_brand: state.PlatformManagement.Bike_management.filters.model_OR_brand,
    model_OR_brand_value: state.PlatformManagement.Bike_management.filters.model_OR_brand.value,
});

export default connect(mapStateToProps)(BikeSearch);



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/components/BikeSearch.js